import React from "react";
import StoreContext from './../../../Store/Context';
import { NavLink as RRNavLink } from "react-router-dom";
import { NavItem, Navbar, Nav, NavLink, Row, Col, Container } from "reactstrap";
import { LOGO_SCHOOL } from "../../Constants/SrcImages";
import "../../../www/css/style.css";
interface IAdminState{
  children:any;
}
interface IAdminProps {
  children:any;
}
class LayoutContabilidad extends React.Component<IAdminProps, IAdminState>{
  static contextType = StoreContext
  constructor(props: IAdminProps) {
    super(props);
    this.state = {
      children:props.children
    };
  }

  updateTokens = () => {
    const test = this.context
    test.quitToken()
  };

  render() {
    return (
      <React.Fragment>
        <Container className="themed-container" fluid={true}>
          <Row>
            <Col sm={2}>
              <Row>
                <Navbar>
                  <Nav tabs>
                    <NavItem className="text-center w-100">
                        <img className="logo-contabilidad" src={LOGO_SCHOOL} alt="" />
                    </NavItem>  
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/contabilidad/personas" activeClassName="active">
                        Personas
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/contabilidad/r-pagos" activeClassName="active">
                      Registro de pagos
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/contabilidad/montos" activeClassName="active">
                        Montos
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/contabilidad/cuentas" activeClassName="active">
                        Cuentas
                      </NavLink>
                    </NavItem>
                    {/* <NavItem className="text-center w-100">
                      <NavLink tag={RRNavLink} to="/contabilidad/estado-cuentas" activeClassName="active">
                        Estado de cuentas
                      </NavLink>
                    </NavItem> */}
                    {/* <NavItem className="text-center w-100">
                      <NavLink  tag={RRNavLink} to="/contabilidad/email" activeClassName="active">
                        Correos
                      </NavLink>
                    </NavItem> */}
                    <NavItem className="text-center w-100">
                      <NavLink  tag={RRNavLink} to="/contabilidad/informes" activeClassName="active">
                        Informes
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-100"  onClick={()=> this.updateTokens()} >
                      <NavLink>
                        Salir
                      </NavLink>
                    </NavItem>
            
                  </Nav>
                </Navbar>
              </Row>
            </Col>
            <Col sm={10}>{this.props.children}</Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default LayoutContabilidad;